import * as Yup from "yup";

// const validation = "^[A-Za-z]{6}[0-9]{10}$";

const validationSchema = (companyObject: any) =>
  Yup.object().shape({
    invoiceNumber: Yup.string()
      .required("Invoice Number is required.")
      .test(
        "companyCheck",
        `Invoice Number is invalid and should be in the format(${companyObject.invoiceNumberExample})`,
        function (value) {
          const regexPattern = companyObject.invoiceNumberFormat;
          const regex = new RegExp(regexPattern);
          return regex.test(value);
        },
      ),
    //   invoiceNumber: Yup.string()
    //     .required("Invoice Number is required.")
    //     .matches(
    //       new RegExp(validation),
    //       "Invalid Invoice Number format should be like (IRDASD2324000918)",
    //     ),
    invoiceDate: Yup.date().required("Invoice Date is required."),
    invoiceAmount: Yup.number().required("Invoice Amount is required."),
    checkedNumberOfBox: Yup.number().required("Number of Box is required."),
    checkedLineItem: Yup.number().required("Line Item is required."),
  });

export { validationSchema };
